import React from 'react';
import { FormLabel } from '@mui/material';
import { Tooltip, TooltipProvider } from '@components/ui/Tooltip';
import { InvoiceClassification } from '@types';

interface ClassificationSelectorProps {
  classification: InvoiceClassification;
  onChange: (classification: InvoiceClassification) => void;
  disabled: boolean;
}

export const ClassificationSelector: React.FC<ClassificationSelectorProps> = ({
  classification,
  onChange,
  disabled
}) => {
  const classifications = [
    { value: 'deliver_direct' as const, label: 'DD', tooltip: 'Dealer Direct' },
    { value: 'head_office' as const, label: 'HO', tooltip: 'Head Office' },
    { value: 'expenses' as const, label: 'EXP', tooltip: 'Expenses' },
    { value: 'credit_note' as const, label: 'CN', tooltip: 'Credit Note' }
  ];

  return (
    <TooltipProvider>
      <div className="space-y-2">
        <FormLabel 
          component="legend" 
          sx={{ 
            fontSize: '0.875rem', 
            fontWeight: '500', 
            color: disabled ? '#9ca3af' : '#374151', 
            display: 'block' 
          }}
        >
          Invoice Classification
        </FormLabel>
        <div className="flex gap-3">
          {classifications.map(({ value, label, tooltip }) => (
            <Tooltip key={value} content={tooltip}>
              <label 
                className={`flex items-center space-x-2 p-2 rounded-md transition-colors ${
                  disabled 
                    ? 'cursor-not-allowed opacity-50' 
                    : 'cursor-pointer'
                } ${
                  classification === value 
                    ? 'text-primary-700' 
                    : ''
                }`}
              >
                <input
                  type="radio"
                  name="classification"
                  value={value}
                  checked={classification === value}
                  onChange={(e) => onChange(e.target.value as InvoiceClassification)}
                  disabled={disabled}
                  className="w-4 h-4 text-primary-600 border-gray-300 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
                />
                <span className="text-sm font-medium">{label}</span>
              </label>
            </Tooltip>
          ))}
        </div>
      </div>
    </TooltipProvider>
  );
};
